import React from 'react';
import { BarsOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Avatar, Badge, Button, Space, Tooltip } from 'antd';
import useAuth from 'hooks/useAuth';
import Logo from 'components/Logo/Logo';
import PerfilSwitcher from './PerfilSwitcher';
import { useAyuda } from 'components/ayuda';

const HeaderSide = (props) => {
  const { collapsed, setCollapsed, openProfile } = props;
  const { user } = useAuth();
  const { abrir, novedades } = useAyuda();

  return (
    <div className="flex items-center justify-between h-full w-full">
      {/* Toggle Button */}
      <div className="flex items-center">
        <Button
          type="text"
          className="flex items-center justify-center w-10 h-10 rounded-lg hover:bg-gray-100"
          icon={<BarsOutlined className="text-lg" />}
          onClick={() => setCollapsed(!collapsed)}
        />
      </div>

      {/* Logo */}
      <div className="flex-1 flex justify-center">
        <div className="flex items-center h-12 max-h-12 overflow-hidden">
          <Logo simple />
        </div>
      </div>

      {/* Right section: perfil switcher + user profile */}
      <div className="flex items-center gap-2">
        <Tooltip
          title={
            novedades.sinLeer > 0
              ? `Centro de ayuda · ${novedades.sinLeer} novedad(es)`
              : 'Centro de ayuda'
          }
        >
          <Badge count={novedades.sinLeer} size="small" offset={[-4, 4]}>
            <Button
              type="text"
              aria-label="Centro de ayuda"
              icon={<QuestionCircleOutlined className="text-lg" />}
              onClick={() => abrir({ deEstaPantalla: true })}
            />
          </Badge>
        </Tooltip>
        <PerfilSwitcher />

        {/* User Profile */}
        <div
          className="flex items-center space-x-2 cursor-pointer hover:bg-gray-50 rounded-lg px-3 py-2 transition-colors"
          onClick={openProfile}
        >
          <div className="hidden sm:block">
            <p className="text-sm font-medium text-gray-700 capitalize truncate max-w-32">
              {user?.fullname || 'Usuario'}
            </p>
          </div>
          <Avatar
            size="small"
            className="border-2 border-gray-200"
            style={{ backgroundColor: '#1890ff' }}
          >
            {user?.fullname?.charAt(0)?.toUpperCase() || 'U'}
          </Avatar>
        </div>
      </div>
    </div>
  );
};

export default HeaderSide;
